import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Messages } from 'primereact/messages';
import { Password } from 'primereact/password';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import axiosClient, { useQuery } from '../constants';
import '../styles/_ResetPassword.css';
const VerifyRegistration = () => {
    const query = useQuery();
    const hash = query.get('hash')
    const id = query.get('userId')
    //const tenantId = query.get('tenantId')
    var tenantid='utility'
    const fname = query.get('fname')
    const lname = query.get('lname')
    const password =query.get('pw')
    const email = query.get('email')


    const { userId } = useParams();
    const [linkStatus, setLinkStatus] = useState('');
    const[headerMessage,setHeaderMessage]= useState('Congratulations you have successfully registered');

    const messages = useRef(null);

    useEffect(() => {
        console.log('Inside useeffect');
        axiosClient.get(`/verify-registration-link/${userId}/${hash}`)
        .then(res => {
            if (res.data !== 'Success') {
                setLinkStatus(res.data)
                setHeaderMessage('Registration Failed!!')
            }
            if (res.data === 'Success') {
                registerUser();
            }

        }).catch(console.error)
    }, [hash, userId])

    const registerUser = () => {        
        const userObj =
            {
                id: id,
                tenantId : "utility",
                groupId: "TESTGRP",
                subGroupId: "SUBGPR",
                role: "UTILITY-USER",
                password: password,
                fname: fname,
                lname: lname,
                email: email,
                s3bucket: "taxreco",
                endDateTime: null,
                userGroup: "REGULAR_USER",
                permissionGroup: "SUPER_USER",
                changepassword:false
            }
        
        axiosClient.post(`/register`,userObj).then(() => {
            messages.current.show({ severity: 'success', summary: 'Success', detail: 'SUCCESSFULLY REGISTERED' });
            setTimeout(() => {
                window.location.href = '#/login'
            }, 3000)
        })
    };
 

    return <div>
        <div className="app-topbar">
            <img alt="Logo" src="assets/layout/images/l.png" className="topbar-logo" />
        </div> 
        <div className="main-container">
            <div className="main-content">
            
                <h1>{headerMessage}</h1>
            
                <Messages ref={messages} />
                {
                    linkStatus.length > 0
                        ?
                        <p>{linkStatus}</p>
                        :
                        <div>
                                
                    
                           <h2>redirecting to login page ...</h2> 
                           
                        </div>
                }


            </div>
        </div>
    </div>
}
export default VerifyRegistration;